export const formatUsername = (user) => {
  if (!user) {
    return undefined;
  }

  if (user.field_first_name?.und?.[0]?.value) {
    let name = '';
    name = user.field_first_name.und[0].value;

    if (user.field_last_name?.und?.[0]?.value) {
      name += ` ${user.field_last_name.und[0].value[0]}.`;
    }

    return name;
  }

  return user.name;
};
